import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { Button, Col, FormGroup, Input, Label } from "reactstrap";
import { setCurrency } from "../../../actions/authActions";
import { Message, Or, PreloadState } from "../../UI/preloading/PreloadState";
import SupportLink from "../../root/support/components/SupportLink";
import { findAllCurrencies } from "../../../helpers/api/currency";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import handleErrorMessage from "../../../helpers/errors/handleErrorMessage";
import { updateConfig } from "./../../../helpers/api/condominium";
import { fetchAllPages } from "../../../helpers/api/pagination";
const ModalSelectedMoneyType = ({ open, toggle }) => {
  //
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const { currency } = useSelector((state) => state.auth);
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const loadMoneyType = async () => {
    setLoading(true);
    await fetchAllPages((page, pageSize) => findAllCurrencies(page, pageSize, {
      condominium_id: selectedCondominium,
    }))
      .then(({ data }) => {
        setData(data);

        // Si solo hay una moneda disponible para este condominio y aún no hay
        // ninguna seleccionada, se asigna automáticamente en vez de obligar a
        // elegirla a mano (mismo criterio que al seleccionar el condominio).
        if (data?.length === 1 && !currency) {
          saveCurrencySelected(String(data[0].id));
        }
      })
      .catch((error) => handleErrorMessage(error))
      .finally(() => setLoading(false));
  };

  const saveCurrencySelected = async (selected) => {
    setLoading(true);
    try {
      await updateConfig(selectedCondominium, {
        automatic: 0,
        currency_id: selected ? Number(selected) : null,
      })
        .then(() => dispatch(setCurrency(selected)))
        .catch((error) => handleErrorMessage(error))
        .finally(() => {
          setLoading(false);
          toggle();
        });
    } catch (error) {
      handleErrorMessage(error);
    }
  };

  useEffect(() => {
    open && loadMoneyType();
  }, [open]);

  return (
    <Modal centered isOpen={open} toggle={toggle}>
      <PreloadState cond={Boolean(data?.length)} loading={loading}>
        <Or value={true}>
          <ModalHeader>Configuración de moneda seleccionada</ModalHeader>
          <ModalBody>
            <Row form>
              <p>
                Selecciona la moneda, esta configuración afecta todos los montos
                del sistema, configurandola verás la tasa de cambio con la
                moneda base.
              </p>
            </Row>
            <Row form>
              <Col tag={FormGroup}>
                <Label>Moneda seleccionada:</Label>
                <Input
                  type="select"
                  defaultValue={currency}
                  onChange={({ target }) => {
                    const selectedValue = target.value;

                    // If no value is selected (deselect option), dispatch empty and save null configuration to backend
                    if (!selectedValue) {
                      dispatch(setCurrency(""));
                      saveCurrencySelected("");
                      return;
                    }

                    dispatch(setCurrency(selectedValue));
                    saveCurrencySelected(selectedValue);
                  }}
                  disabled={loading}
                >
                  <option value="">
                    Selecciona una moneda
                  </option>
                  {data.map((item) => (
                    <option key={item.id} value={item.id}>
                      ({item.iso}) {item.name}
                    </option>
                  ))}
                </Input>
              </Col>
            </Row>
            <Row form className="justify-content-center align-items-center ">
              <SupportLink />
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={toggle}>
              Cerrar ventana
            </Button>
          </ModalFooter>
        </Or>
        <Message value={false} icon={null}>
          <p>No hay tipos de monedas</p>
          <div>
            <Button color="primary" onClick={toggle}>
              Cerrar ventana
            </Button>
          </div>
          <div className="mt-2">
            <Link to="/dashboard/exchange">
              <small>Ir a configurar monedas ➜</small>
            </Link>
          </div>
        </Message>
      </PreloadState>
    </Modal>
  );
};

export default ModalSelectedMoneyType;
